import { Helmet } from "react-helmet-async";

const SITE_NAME = "Inioli";
const SITE_URL = "https://inioli.com";
const DEFAULT_DESCRIPTION =
    "Custom cakes, sweets, and tailoring (aari work, blouse stitching, alterations) in East Brunswick, NJ. Pickup or delivery within 25 miles.";
const DEFAULT_IMAGE = `${SITE_URL}/inioli-logo-only.png`;

// path should start with "/" (e.g. "/cake") - pass "" for the homepage.
const Seo = ({ title, description = DEFAULT_DESCRIPTION, path = "", image = DEFAULT_IMAGE, noindex = false }) => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Custom Cakes & Tailoring in East Brunswick, NJ`;
    const url = `${SITE_URL}${path}`;
    const absoluteImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={absoluteImage} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={absoluteImage} />
        </Helmet>
    );
};

export default Seo;
export { SITE_NAME, SITE_URL, DEFAULT_DESCRIPTION };
